module.exports = __webpack_public_path__ + "static/mr-concert-performance-12-f1ae9cee7688990a3c691760c51d008d.jpg";